import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { NEW_PASSWORD_API_URL } from '../../../../constants/ApiUrlConstants';
import { LOGIN_ROUTE } from '../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import history from '../../../../features/history';
import { newPasswordFailure, newPasswordSuccess } from '../actions';

const NewPasswordAPI = (action) => postApiRequest(NEW_PASSWORD_API_URL, action);

function forwardTo(location) {
  history.push(location);
}

function* handleNewPasswordAPI(action) {
  try {
    const response = yield call(NewPasswordAPI, action.payload);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    if (response?.data?.success) {
      yield call(forwardTo, LOGIN_ROUTE);
    }
    yield put(newPasswordSuccess(response));
  } catch (error) {
    yield put(newPasswordFailure(error));
  }
}

export function* watchNewPassword() {
  yield takeLatest(types.NEW_PASSWORD_REQUEST, handleNewPasswordAPI);
}
